import { SignalRContext } from 'contexts/SignalRContext';
import { useContext } from 'react';

export const useSignalR = () => useContext(SignalRContext);
